<template>
  <v-dialog v-model="dialog" max-width="400" persistent>
    <v-card class="1">
      <v-btn
        data-cy-close
        icon
        @click="$emit('close')"
        class="float-right mt-2 mr-2"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-text data-cy-help-description class="pt-10 body-1">
        <p v-html="description"></p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DescriptionDialog",
  props: {
    dialog: { type: Boolean },
    description: { type: String }
  }
};
</script>
